import { Component, HostBinding, HostListener, Input } from '@angular/core';
import { InputControlBase } from '../../forms/input-control.base';
import { AstralFieldShellComponent } from '../astral-field-shell/astral-field-shell.component';
import { shouldShowAstralValidationError } from '../astral-validation-state';
import { AstralFieldAccessibilityDirective } from '../astral-field-accessibility.util';
import { AstralTemporalInputDirective } from '../astral-temporal-input/astral-temporal-input.directive';

@Component({
  selector: 'astral-time-picker',
  standalone: true,
  imports: [AstralFieldShellComponent, AstralFieldAccessibilityDirective, AstralTemporalInputDirective],
  templateUrl: './astral-time-picker.component.html',
  styleUrls: ['./astral-time-picker.component.scss'],
})
export class AstralTimePickerComponent extends InputControlBase<string> {
  private static nextId = 0;
  private readonly uid = `astral-time-picker-${++AstralTimePickerComponent.nextId}`;
  @Input() autocomplete = 'off';
  @Input() inputId: string;
  @Input() inputName: string;
  @Input() label: string;
  @Input() readonly = false;
  @Input() disabled = false;

  @HostBinding('tabindex') tabindex = -1;

  get resolvedInputId(): string {
    return this.inputId ?? this.uid;
  }

  get resolvedInputName(): string {
    if (this.inputName) {
      return this.inputName;
    }

    const caption = (this.control?.caption ?? this.label)
      ?.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return caption || this.uid;
  }

  get resolvedLabel(): string | null {
    return this.label ?? this.control?.caption ?? null;
  }

  get resolvedReadonly(): boolean {
    return this.readonly || this.control?.isReadonly || false;
  }

  get resolvedDisabled(): boolean {
    return this.disabled || this.control?.disabled || false;
  }

  get resolvedRequired(): boolean {
    return this.control?.required || false;
  }

  get invalid(): boolean {
    return shouldShowAstralValidationError(this.control);
  }

  @HostListener('focus')
  focusHost(): void {
    document.getElementById(this.resolvedInputId)?.focus();
  }

  handleTimeChange(value: string): void {
    this.control?.setValue(value || null);
    this.control?.markAsDirty();
  }

  handleFocus(): void {
    this.onfocus();
  }

  handleBlur(): void {
    this.control?.markAsTouched();
    this.onblur();
  }
}
